<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="合同协议号">
              <a-input v-model="queryParam.contract_protocol_number" placeholder="合同协议号" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1000 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="approval_needed" slot-scope="text, item">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(item, undefined, false)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a-popconfirm
            v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"
            title="确定重启审批?"
            @confirm="() => approvalNeeded(record, 'logistics', true)">
            <span>重启审批</span>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"/>
          <a @click="handleAttachment(record)">附件</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical"v-if="isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archived_visible"
      :visible="archived_visible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  logistics_list,
  logistics_create,
  logistics_delete,
  logistics_archived, logistics_update
} from '@/api/trade_logistics'
import CreateForm from '../modules/CreateForm'
import ArchivedForm from '../modules/ArchivedForm'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ArchivedForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '合同编号',
          dataIndex: 'system_contract_number',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '合同协议号',
          dataIndex: 'contract_protocol_number',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '购销合同编号',
          dataIndex: 'sell_contract_number',
          width: 150,
          ellipsis: true
        },
        {
          title: '交货运输方式',
          dataIndex: 'transport_way',
          ellipsis: true,
          width: 120,
          customRender: (text) => this.$Dictionaries.trade_logistics_transport_way[text] || '无'
        },
        {
          title: '交货运输工具名称',
          dataIndex: 'delivery_conveyance',
          width: 150,
          ellipsis: true
        },
        {
          title: '交货日期',
          dataIndex: 'delivery_date',
          width: 150,
          ellipsis: true
        },
        {
          title: '交货地',
          dataIndex: 'delivery_address',
          width: 150,
          ellipsis: true
        },
        {
          title: '提货日期',
          dataIndex: 'pick_up_date',
          width: 150,
          ellipsis: true
        },
        {
          title: '提货地',
          dataIndex: 'pick_up_address',
          width: 150,
          ellipsis: true
        },
        {
          title: '提货运输方式',
          dataIndex: 'pick_up_transport_way',
          width: 120,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_logistics_transport_way[text] || '无'
        },
        {
          title: '提货运输工具名称',
          dataIndex: 'pick_up_conveyance',
          width: 150,
          ellipsis: true
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return logistics_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      this.mdl = { number: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        this.loading = true
        logistics_update({ is_approval_needed: true }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        logistics_update({ is_approval_needed: !record.is_approval_needed }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        })
      }
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/logistics/' + record.id + '/attachment', query: { record: record.name } })
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/logistics/' + record.id })
    },
    handleDelete (record) {
      logistics_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          values['attachment'] = data['attachment']
          this.confirmLoading = true
          logistics_create(values).then(res => {
              // 刷新表格
              if (res.code === 1000) {
                this.visible = false
                // 重置表单数据
                form.resetFields()
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          logistics_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
